import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import kategori from './kategori'
import bahanBaku from './bahan-baku'
import divisi from './divisi'
import supplier from './supplier'
import settings from './settings'
import aksesMenu from './akses-menu'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    divisi, settings, kategori, bahanBaku, supplier, aksesMenu
  },
  plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js